"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var calculators_1 = require("../../utils/calculators");
var utils_1 = require("../../utils/utils");
/**
 * @component StartAndEndText
 * @example
 * <StartAndEndText startText="test" endText="endText" />
 *
 * @param {string} startText the start text
 * @param {number | string} endText the end text
 * @param {boolean} hasPositiveNegativeEndTextColor boolean to decide if we want to have a red or green text color for numbers on end text
 */
var StartAndEndText = function (props) {
    var startText = props.startText, endText = props.endText, _a = props.hasPositiveNegativeEndTextColor, hasPositiveNegativeEndTextColor = _a === void 0 ? false : _a;
    return (react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 },
        react_1.default.createElement(material_1.Grid, { item: true, xs: 8 },
            react_1.default.createElement(material_1.Typography, { variant: "subtitle2" }, startText)),
        react_1.default.createElement(material_1.Grid, { item: true, xs: 4 },
            react_1.default.createElement(material_1.Box, { display: "flex", justifyContent: "flex-end" },
                react_1.default.createElement(material_1.Typography, { variant: "subtitle2" },
                    typeof endText === "number" && react_1.default.createElement("span", { className: utils_1.Utils.setPositiveNegativeNumberTextColor(hasPositiveNegativeEndTextColor, endText) }, (0, calculators_1.formatNumberToUSD)(endText)),
                    typeof endText === "string" && endText)))));
};
exports.default = StartAndEndText;
